<template>
  <div class="component_card">
    <div
      class="column text_m_blu tal_c p30-l-r main_blue_dk_bg"
      style="font-size: 18px; color: white; border-radius: 8px 8px 0px 0px"
    >
      <span>
        {{ $t("msg.available_balance") }} {{ this.getUnlockedBalance() }} BLUE
      </span>
    </div>
    <div class="redeem_form mw100">
      <div>
        <div>
          <div
            class="column pb0"
            v-bind:class="{
              has_error_color: !validation.amount || bluAmount < minBlue,
            }"
          >
            <div
              style="
                display: flex;
                justify-content: center;
                margin-bottom: 30px;
                flex-direction: column;
              "
            >
              <div style="width: 100%; display: flex; justify-content: center">
                <img
                  class="blu_balance_img"
                  src="../../../../assets/images/1.png"
                />
              </div>
              <div
                style="
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  font-size: 9px;
                "
              >
                <div style="width: 60%; display: flex; justify-content: center">
                  <span style="margin-left: 10px; color: #02b9a4">{{
                    $t("msg.step_amount")
                  }}</span>
                  <span style="margin-left: 25px">{{
                    $t("msg.step_recipient")
                  }}</span>
                  <span style="margin-left: 25px">{{
                    $t("msg.step_verification")
                  }}</span>
                  <span style="margin-left: 20px">{{
                    $t("msg.step_authentication")
                  }}</span>
                </div>
              </div>
            </div>

            <p
              class="tal_c main_blue_dk_fill fat"
              v-if="redeemPreview.targetCurrency"
              style="margin-bottom: 30px"
            >
              {{ $t("msg.input_blue_amount") }}
            </p>

            <p
              class="tal_c"
              v-if="redeemPreview.targetCurrency"
              style="margin-bottom: 30px"
            >
              {{ $t("msg.input_amount_redeem") }}
              <span class="block">
                {{ $t("msg.min_amount_is") }}: {{ minBlue }} BLUE
              </span>
            </p>

            <div class="column blu_input_container_2">
              <img
                class="blu_input_img_2"
                src="../../../../assets/images/blue_icon.svg"
              />

              <div class="blu_input_2">
                <input
                  class="amount_redeem"
                  v-model="bluAmount"
                  v-on:keypress="isNumber()"
                  v-bind:class="{
                    has_error_color: !validation.amount || bluAmount < minBlue,
                  }"
                />
              </div>

              <div class="blu_input_actions">
                <div class="blu_input_plus" @click="modifyBluAmount('+')">
                  <p v-html="iconSets.general_up"></p>
                </div>
                <div
                  class="blue_input_minus"
                  @click="modifyBluAmount('-')"
                  :class="{
                    arrow_disabled:
                      parseFloat(bluAmount) <= parseFloat(minBlue),
                  }"
                >
                  <p v-html="iconSets.general_down"></p>
                </div>
              </div>
            </div>
          </div>

          <p class="tal_c">
            <span
              class="text_sm has_error_text"
              v-if="!validation.amount || bluAmount < minBlue"
              >{{ $t("msg.invalid_amount") }}.</span
            >
          </p>

          <div
            class="column m13_t"
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            "
          >
            <div style="width: 70%" class="custon-w-m">
              <p v-if="bluValue" class="fat" style="margin-bottom: 5px">
                <span
                  class="icon_class_1 background_ val_m background_USDT"
                ></span>
                <strong>{{ $t("msg.equivalent") }} USDT:</strong>
                {{ (bluValue[0].value * bluAmount) | decimalsCrypto(2) }}
              </p>

              <div v-if="bluValue">
                <div
                  v-if="
                    redeemInfo.wave &&
                    redeemInfo.waveRule >= bluValue[0].value * bluAmount
                  "
                >
                  <span
                    style="opacity: 0"
                    class="icon_class_1 background_ val_m background_USDT"
                  ></span>
                  {{ $tc("msg.fee") }}:
                  <span>{{ redeemInfo.feeWave.toFixed(2) }} USDT</span>
                </div>

                <div v-else>
                  <span
                    style="opacity: 0"
                    class="icon_class_1 background_ val_m background_USDT"
                  ></span>
                  {{ $tc("msg.fee", 1) }} ({{ feeTax.fee }}%):
                  <span
                    v-if="
                      (bluValue[0].value * bluAmount * feeTax.fee) / 100 >=
                      feeTaxAbsolute.fee
                    "
                    >{{
                      (
                        (bluValue[0].value * bluAmount * feeTax.fee) /
                        100
                      ).toFixed(2)
                    }}</span
                  >
                  <span v-else>{{ feeTaxAbsolute.fee.toFixed(2) }} USDT</span>
                </div>

                <!-- <div v-else>
                  <span
                    style="opacity: 0"
                    class="icon_class_1 background_ val_m background_USDT"
                  ></span>
                  {{ $tc("msg.fee") }}:
                  <span>{{ redeemInfo.feeWave }} USDT</span>
                </div> -->
              </div>
              <p
                v-if="bluValue"
                style="margin-bottom: 5px; font-size: 13px; margin-left: 25px"
              >
                <span
                  class="fs_0001r"
                  v-if="
                    redeemInfo.wave &&
                    redeemInfo.waveRule >
                      bluValue[0].value * bluAmount * feeTax.fee
                  "
                >
                  {{ $t("msg.fee_redeem_wave_info") }}
                </span>

                <span class="fs_0001r" v-else>
                  {{ $t("msg.fee_info_redeem_one") }} {{ feeTax.fee }}%
                  {{ $t("msg.fee_info_redeem_two") }}
                  {{ feeTaxAbsolute.fee }} USDT
                </span>
              </p>
              <p v-if="bluValue" class="fat">
                <span
                  style="opacity: 0"
                  class="icon_class_1 background_ val_m background_USDT"
                ></span>
                {{ $t("msg.total_to_receive") }}: {{ getTotalWithFee() }} USDT
              </p>
            </div>
          </div>

          <!-- <div
            class="column"
            v-bind:class="{ has_error: !validation.address && address != '' }"
          >
            <p class="fat">{{ $t("msg.send_to_btc_adress_destination") }}:</p>
            <div class="custom-flex">
              <div class="icon-container">
                <span
                  class="icon_class_2 background_ val_m background_BTC mauto"
                ></span>
              </div>
              <input
                class="amount_address"
                type="text"
                v-model="address"
                style="width: 100%"
                @keyup="validateAdress(address)"
              />
            </div>
            <p class="text_xxs_px column">
              Make sure to inform the right Destination Address to ensure that
              the amount is sent to your address.
            </p>

            <p class="tal_c">
              <span
                class="text_sm has_error_text"
                v-if="!validation.address && address != ''"
                >{{ $t("msg.error_redeem_address") }}</span
              >
            </p>
          </div> -->
          <div class="column">
            <button
              class="btn_redeem btn_radius"
              @click="callNextStep()"
              :disabled="!validation.amount || bluAmount < minBlue"
            >
              {{ $t("msg.next_step") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["feeTax", "feeTaxAbsolute", "redeemInfo"],
  created() {
    this.checkAmount();
    this.setMinAmount();
    this.getRedeemFee();
  },
  data: () => ({
    redeem_error: "",
    WAValidator: require("wallet-address-validator"),
    bluAmount: 0,
    minBlue: 0,
    maxBluAmount: 99999999999,
    address: "",
    toolTipRedeem: false,
    unLockedBalance: "",
    redeemPreview: "",
    fee: 0.002,
    feeRedeem: "",
    fixedFee: "",
    validation: {
      amount: false,
      address: false,
    },
    redeem: {
      sourceAmount: "",
      targetCurrency: "USDT",
    },
  }),
  methods: {
    getTotalWithFee() {
      let total = this.bluValue[0].value * this.bluAmount;

      if (this.redeemInfo.wave && !(total >= this.redeemInfo.waveRule + 1)) {
        let fee = this.redeemInfo.feeWave;
        this.feeRedeem = fee;
        let result = (total - fee).toFixed(2);
        if (result > 0) {
          return result;
        } else {
          return 0;
        }
      } else {
        let fee =
          (this.bluValue[0].value * this.bluAmount * this.feeTax.fee) / 100;

        if (fee >= this.feeTaxAbsolute.fee) {
          this.feeRedeem = fee;
          let result = (total - fee).toFixed(2);
          if (result > 0) {
            return result;
          } else {
            return 0;
          }
        } else {
          this.feeRedeem = this.feeTaxAbsolute.fee;
          let result = (total - this.feeTaxAbsolute.fee).toFixed(2);
          if (result > 0) {
            return (total - this.feeTaxAbsolute.fee).toFixed(2);
          } else {
            return 0;
          }
        }
      }
    },
    setRedeemError() {
      if (this.bluAmount < this.minBlue) {
        this.redeem_error = "below_min";
      } else {
        this.redeem_error = "no_funds";
      }
    },
    callNextStep() {
      this.$emit(
        "callNext",
        this.bluAmount,
        this.address,
        this.feeRedeem,
        this.redeemPreview
      );
    },

    async postPreview() {
      this.redeem.sourceAmount = parseFloat(this.bluAmount);
      let resp = await this.$store.dispatch("postRedeemPreview", this.redeem);
      this.redeemPreview = resp.data;
    },

    async getRedeemFee() {
      let resp = await this.$store.dispatch("getFees");
      let fees = resp.data;

      let arrayFee = [];

      for (let i in fees) {
        if (fees[i].type == "redeem") {
          arrayFee.push(fees[i].fee);
        }
      }

      this.feeRedeem = 0.001;
    },

    setMinAmount() {
      let bluValue = this.bluValue[0].value;

      console.log(this.bluValue[0].redeemMinimal);

      let redeemMinimun = this.bluValue[0].redeemMinimal;
      let min = redeemMinimun / bluValue;

      this.minBlue = min.toFixed(6);
      this.bluAmount = min.toFixed(6);
      this.postPreview();
    },

    checkAmount() {
      this.getUnlockedBalance();

      console.log(this.redeemPreview);

      if (this.redeemPreview) {
        if (
          this.redeemPreview.targetAmount >= 0 &&
          parseFloat(this.bluAmount) <= this.unLockedBalance
        ) {
          this.validation.amount = true;
        } else {
          this.validation.amount = false;
        }
      }
    },

    validateAmount() {
      this.bluAmountValid = false;
      let indices = [];
      let amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }
      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
    },
    getUnlockedBalance() {
      if (this.bluAccount) {
        let totalBalance = this.bluAccount.balance;
        let lockedBalace = this.bluAccount.locked;
        let unLockedBalance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
        return this.unLockedBalance.toFixed(6);
      }
    },
    validateAdress(address) {
      let valid = this.WAValidator.validate(address, "BTC");
      if (valid) {
        this.validation.address = true;
      } else {
        this.validation.address = false;
      }
    },
    showToolRedeem() {
      this.toolTipRedeem = true;
    },
    hideToolRedeem() {
      this.toolTipRedeem = false;
    },
    modifyBluAmount(modifier) {
      if (
        this.bluAmount == false ||
        this.bluAmount < this.minBlue ||
        this.bluAmount == ""
      ) {
        this.bluAmount = parseFloat(this.minBlue).toFixed(4);
      } else {
        if (modifier == "-" && this.bluAmount > 0) {
          let result = this.bluAmount - 1;
          if (result > this.minBlue) {
            this.bluAmount = parseFloat(result).toFixed(4);
          } else {
            this.bluAmount = parseFloat(this.minBlue).toFixed(4);
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = (parseFloat(this.bluAmount) + 1).toFixed(4);
        }
      }
    },
    roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },
    isNumber() {
      let evt = window.event;
      var charCode = evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  computed: {
    ...mapGetters([
      "btcValue",
      "bluValue",
      "bluAccount",
      "ethValue",
      "rasValue",
    ]),
  },
  watch: {
    bluAmount: function () {
      this.postPreview();
      this.setRedeemError();
      this.validateAmount();
    },
    redeemPreview: function () {
      this.checkAmount();
    },
  },
};
</script>
<style scoped>
.icon-container {
  background: white;
  width: 70px;
  border-style: solid;
  border-width: 1px 0px 1px 1px;
  border-color: #e3d4d4;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/private/services/redeem_steps/RedeemStep1.vue